import QuizStatuses from '@/constant/QuizStatuses'

export const shouldShowLeaderboardVisibilityToggle = ({ slides, isLive }) => {
  if (!slides || slides.length == 0) return false
  const hasAtLeastAQuizSlide = slides?.some((slide) => slide.type == 'pickAnswer')
  return hasAtLeastAQuizSlide && isLive
}

export const shouldShowLeaderboardAfterQuizWhenPressNext = ({ slide }) => {
  return slide &&
    slide.isLeaderboardEnabled &&
    slide.quizStatus === QuizStatuses.RESULT_SCREEN &&
    slide.type === 'pickAnswer'
}
